// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarOutlinedSvg from "@fishx/icons-svg/es/asn/DollarOutlined";
import FishxIcon from '../components/FishxIcon';

var DollarOutlined = function DollarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarOutlinedSvg
  }));
};

DollarOutlined.displayName = 'DollarOutlined';
export default React.forwardRef(DollarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DollarOutlined.js
// module id = 2439
// module chunks = 0